export default {
    methods: {
        requiredRule(name, message) {
            return (v) => !!v || (message ?? `${name} is required`);
        },
    },
};
